import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { filterSingleGroupSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleGroupSelector_template";

declare var ko: any;

export class task_scheduling_template extends vnTemplate {

    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected validationsList: validationsList_template;

    public operationFilterAutocomplete: filterAutocomplete_template;
    public operationFormAutocomplete: filterAutocomplete_template;
    public taskExecuterFilterAutocomplete: filterAutocomplete_template;
    public taskExecuterFormAutocomplete: filterAutocomplete_template;
    public scheduleTypeDropdown: filterDropdown_template;
    public executeScheduledDropdown: filterDropdown_template;
    public brandfilter: filterSingleGroupSelector_template;
    public taskExecuterGroupDropdown: filterSingleGroupSelector_template;

    protected getTemplateHtml(): string {

        // <div style="margin-bottom: -1.2rem;">
        //     <label class="form-label form-label-box">Brand</label>
        //     ${this.brandfilter.getHtmlBuild()}
        // </div>
        return /*html*/`
            <div class="sub-header w-justify">
                <div class="w-left">
                    <div style="margin-bottom: -1.2rem;"><label class="form-label form-label-box">Brand</label>` + this.brandfilter.getHtmlBuild() + `</div>
                    <div style="margin-bottom: -1.2rem;"><label class="form-label form-label-box" for="" >Pipeline</label>` + this.taskExecuterGroupDropdown.getHtmlBuild() + `</div>         
                    <div>` + this.operationFilterAutocomplete.getHtmlBuild() + `</div>
                    <div>` + this.taskExecuterFilterAutocomplete.getHtmlBuild() + `</div>
        
                    <div style="margin-bottom: -1.2rem;">
                        <label class="form-label form-label-box">Schedule Type</label>
                        ` + this.scheduleTypeDropdown.getHtmlBuild() + `
                    </div>
                    
                    <div style="margin-bottom: -1.2rem;">
                        <label class="form-label form-label-box">Schedule</label>
                        ` + this.executeScheduledDropdown.getHtmlBuild() + `
                    </div>
                </div>
            </div>
        
            <div class="list-header w-justify">
                <div class="w-left">
                    <button data-bind="click: onClickAdd, visible: canWriteTaskScheduling" class="btn secondary icon i-add" type="button">Add Schedule</button>
                </div>
        
                <div class="w-right">
                    ` + this.pagination.getHtmlBuild() + `
                </div>
            </div>
        
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'operationName') }, css: { 'list-sort-desc': orderByAndDirection()=='operationName_DESC', 'list-sort-asc': orderByAndDirection()=='operationName_ASC' }">Operation</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'operationNiceName') }, css: { 'list-sort-desc': orderByAndDirection()=='operationNiceName_DESC', 'list-sort-asc': orderByAndDirection()=='operationNiceName_ASC' }">Operation Desc</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'taskExecuterCode') }, css: { 'list-sort-desc': orderByAndDirection()=='taskExecuterCode_DESC', 'list-sort-asc': orderByAndDirection()=='taskExecuterCode_ASC' }">Task Executer</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'taskExecuterName') }, css: { 'list-sort-desc': orderByAndDirection()=='taskExecuterName_DESC', 'list-sort-asc': orderByAndDirection()=='taskExecuterName_ASC' }">Task Executer Desc</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'executeScheduled') }, css: { 'list-sort-desc': orderByAndDirection()=='executeScheduled_DESC', 'list-sort-asc': orderByAndDirection()=='executeScheduled_ASC' }">Scheduled</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateLastRun') }, css: { 'list-sort-desc': orderByAndDirection()=='dateLastRun_DESC', 'list-sort-asc': orderByAndDirection()=='dateLastRun_ASC' }">Date Last Run</span></th>
                        <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'extraInfo') }, css: { 'list-sort-desc': orderByAndDirection()=='extraInfo_DESC', 'list-sort-asc': orderByAndDirection()=='extraInfo_ASC' }">Extra Info</span></th>
                        <th data-bind="visible: canWriteTaskScheduling"><span>Actions</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: items">
                        <tr>
                            <td data-bind="text: id"></td>
                            <td data-bind="text: operationName"></td>
                            <td data-bind="text: operationNiceName"></td>
                            <td data-bind="text: taskExecuterCode"></td>
                            <td data-bind="text: taskExecuterName"></td>
                            <td data-bind="text: executeScheduled"></td>
                            <td data-bind="text: dateLastRun"></td>
                            <td data-bind="text: extraInfo"></td>
                            <td data-bind="visible: $parent.canWriteTaskScheduling">
                                <div class="w-btn" style="display: flex; flex-direction: row; gap: 4px; white-space: nowrap;">                                    <button class="btn border only-icon icon i-edit" type="button" title="Edit" data-bind="event: { click: $parent.onClickEdit }, clickBubble: false">
                                        <span class="hidden-text">Edit</span>
                                    </button>
                                    <button class="btn border only-icon icon highlight i-delete" type="button" title="Delete" data-bind="event: { click: $parent.onClickDelete }, clickBubble: false">
                                        <span class="hidden-text">Delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        
            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isVisible }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form task-scheduling-lightbox-form" style="max-width: calc(100vw - 4rem); width: 40rem;">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: popupTitle"></h3>
                            <button type="button" data-bind="click: onClickCancel" class="close-button icon i-close-2"></button>
                        </div>
        
                        ` + this.validationsList.getHtmlBuild() + `
        
                        <div class="form-body">
                            <!-- ko if: popupAction() === 'add' -->
                            <div class="form-group">
                                <label class="form-label">Operation</label>
                                ` + this.operationFormAutocomplete.getHtmlBuild() + `
                            </div>
        
                            <div class="form-group">
                                <label class="form-label">Task Executer</label>
                                ` + this.taskExecuterFormAutocomplete.getHtmlBuild() + `
                            </div>
                                <!-- /ko -->
                                
                            <div class="form-group">
                                <label class="form-label">Schedule Type</label>
                                <select class="input-text run-every-unit-select" data-bind="value: form.scheduleMode">
                                    <option value="every">every</option>
                                    <option value="time">time</option>
                                </select>
                            </div>
                            
                            <!-- ko if: form.scheduleMode() === 'every' -->
                            <div class="form-group">
                                <label class="form-label">Run Every</label>
                                <div style="display: flex; gap: 0.5rem;">
                                    <input type="number" min="1" step="1" class="input-text" style="width: 8rem;" data-bind="value: form.scheduleEveryValue">
                                    <select class="input-text run-every-unit-select" data-bind="value: form.scheduleEveryUnit">
                                        <option value="m">minute(s)</option>
                                        <option value="h">hour(s)</option>
                                    </select>
                                </div>
                            </div>
                            <!-- /ko -->
                            
                            <!-- ko if: form.scheduleMode() === 'time' -->
                            <div class="form-group">
                                <label class="form-label">Run At</label>
                                <input type="time" class="input-text" data-bind="value: form.scheduleTime">
                            </div>
                            <!-- /ko -->
        
                            <div class="form-group">
                                <label class="form-label">Extra Info</label>
                                <textarea class="input-text" data-bind="value: form.extraInfo" placeholder='{"key":"value"}'></textarea>
                            </div>
                        </div>
        
                        <div class="form-footer">
                            <button type="button" data-bind="click: onClickCancel" class="btn border only-icon icon">Cancel</button>
                            <button type="button" data-bind="click: onClickSave" class="btn border only-icon icon">Save</button>
                        </div>
                    </div>
                </div>
            </div>
    `;    
    }

    protected initPartial(): void {

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
        this.validationsList = new validationsList_template("taskSchedulingValidationList", this.getTemplateViewModel(), this.caller);
        this.validationsList.setWidth("100%");

        this.operationFilterAutocomplete = new filterAutocomplete_template("operationFilterAutocomplete", this.getTemplateViewModel(), this.caller);
        this.operationFilterAutocomplete.setPlaceholder("All operations");
        this.operationFilterAutocomplete.setNumberOfChars(1);
        this.operationFilterAutocomplete.setFilterIconCSSClass("i-search2");
        this.operationFilterAutocomplete.setHasDisplayNameComplement(true);

        this.taskExecuterFilterAutocomplete = new filterAutocomplete_template("taskExecuterFilterAutocomplete", this.getTemplateViewModel(), this.caller);
        this.taskExecuterFilterAutocomplete.setPlaceholder("All task executers");
        this.taskExecuterFilterAutocomplete.setNumberOfChars(1);
        this.taskExecuterFilterAutocomplete.setFilterIconCSSClass("i-search2");

        this.operationFormAutocomplete = new filterAutocomplete_template("operationFormAutocomplete", this.getTemplateViewModel(), this.caller);
        this.operationFormAutocomplete.setPlaceholder("Select operation");
        this.operationFormAutocomplete.setNumberOfChars(1);
        this.operationFormAutocomplete.setFilterIconCSSClass("i-search2");
        this.operationFormAutocomplete.setHasDisplayNameComplement(true);

        this.taskExecuterFormAutocomplete = new filterAutocomplete_template("taskExecuterFormAutocomplete", this.getTemplateViewModel(), this.caller);
        this.taskExecuterFormAutocomplete.setPlaceholder("Select task executer");
        this.taskExecuterFormAutocomplete.setNumberOfChars(1);
        this.taskExecuterFormAutocomplete.setFilterIconCSSClass("i-search2");

        this.operationFilterAutocomplete.setIsShowCurrentSelection(false);
        this.taskExecuterFilterAutocomplete.setIsShowCurrentSelection(false);
        this.operationFormAutocomplete.setIsShowCurrentSelection(false);
        this.taskExecuterFormAutocomplete.setIsShowCurrentSelection(false);

        this.scheduleTypeDropdown = new filterDropdown_template("scheduleTypeDropdown", this.getTemplateViewModel(), this.caller);
        this.scheduleTypeDropdown.setOptions([
            { id: null, name: "All schedule types" },
            { id: "time", name: "time" },
            { id: "every", name: "every" }
        ]);
        this.scheduleTypeDropdown.setSelectedOption(null);
        
        this.executeScheduledDropdown = new filterDropdown_template("executeScheduledDropdown", this.getTemplateViewModel(), this.caller);
        this.executeScheduledDropdown.setOptions([{ id: null, name: "All schedules" }]);
        this.executeScheduledDropdown.setSelectedOption(null);

        this.brandfilter = new filterSingleGroupSelector_template("brandfilter", this.getTemplateViewModel(), this.caller);
        this.brandfilter.setOptions([{ id: null, name: "All brands" }]);
        this.syncSingleSelectorText(this.brandfilter, "All brands");
        this.brandfilter.setSelectedOption(null);

        this.taskExecuterGroupDropdown = new filterSingleGroupSelector_template("taskExecuterGroupDropdown", this.getTemplateViewModel(), this.caller);
        this.taskExecuterGroupDropdown.setOptions([{ id: null, name: "All task executer groups" }]);
        this.syncSingleSelectorText(this.taskExecuterGroupDropdown, "All task executer groups");
        this.taskExecuterGroupDropdown.setSelectedOption(null);
    }

    protected getTemplateName(): string {

        return "task_scheduling_template";
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected buildViewModel(): any {

        let self = this;

        return {
            items: ko.observableArray([]),
            operationFilter: ko.observable(null),
            taskExecuterFilter: ko.observable(null),
            brandFilter: ko.observable(null),
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("id_DESC"),
            isVisible: ko.observable(false),
            executeSchedules: ko.observableArray([]),
            popupAction: ko.observable("add"),
            popupTitle: ko.pureComputed(function () {
                return self.getTemplateViewModel().popupAction() === "add" ? "Add Schedule" : "Edit Schedule";
            }),
            form: {
                id: ko.observable(null),
                idOperation: ko.observable(null),
                idTaskExecuter: ko.observable(null),
                scheduleMode: ko.observable("every"),
                scheduleEveryValue: ko.observable("1"),
                scheduleEveryUnit: ko.observable("h"),
                scheduleTime: ko.observable("01:00"),
                executeScheduled: ko.observable(""),
                extraInfo: ko.observable("")
            },
            permissions: ko.observableArray(this.initPermissions(["task_scheduling"])),
            canWriteTaskScheduling: ko.pureComputed(function () {
                let permissions = self.getTemplateViewModel().permissions();

                return permissions["task_scheduling"] && permissions["task_scheduling"].write;
            }),
            onClickReorder: function (field) {
                self.onClickReorder(field);
            },
            onClickAdd: function () {
                self.showAddPopup();
            },
            onClickEdit: function (data) {
                self.showEditPopup(data);
            },
            onClickDelete: function (data) {
                self.caller.deleteTaskScheduling(data.id);
            },
            onClickCancel: function () {
                self.hidePopup();
            },
            onClickSave: function () {
                if (!self.isFormValid()) {
                    return;
                }
                self.caller.saveTaskScheduling(self.getFormData());
            }
        };
    }

    public getViewModelForRequest() {

        let vm = this.getTemplateViewModel();
        let scheduleType = vm.scheduleTypeDropdown.selectedOption();
        let executeScheduled = vm.executeScheduledDropdown.selectedOption();
        let taskExecuterGroup = vm.taskExecuterGroupDropdown.selectedOption();
        let brandFilter = vm.brandfilter.selectedOption();

        return {
            orderBy: vm.orderBy(),
            orderByDirection: vm.orderByDirection(),
            orderByAndDirection: vm.orderByAndDirection(),
            pagination: vm.pagination,
            filters: {
                operation: vm.operationFilter(),
                taskExecuter: vm.taskExecuterFilter(),
                brandFilter: brandFilter !== "All brands" ? brandFilter : null,
                scheduleType: scheduleType !== "All schedule types" ? scheduleType : null,
                executeScheduled: executeScheduled && executeScheduled !== "All schedules" ? executeScheduled : null,
                taskExecuterGroup: taskExecuterGroup !== "All task executer groups" ? taskExecuterGroup : null
            }
        };
    }

    public setViewModelFromRequest(urlParams): void {
        if (urlParams == null) {
            return;
        }

        let vm = this.getTemplateViewModel();

        if (urlParams.operation) {
            vm.operationFilter(urlParams.operation);
            this.caller.getOperationById(urlParams.operation);
        }

        if (urlParams.taskExecuter) {
            vm.taskExecuterFilter(urlParams.taskExecuter);
            this.caller.getTaskExecuterById(urlParams.taskExecuter);
        }

        if (urlParams.brandFilter) {
            this.brandfilter.setSelectedOption(urlParams.brandFilter);
            this.syncSingleSelectorText(this.brandfilter, "All brands");
        } else {
            this.brandfilter.setSelectedOption(null);
            this.syncSingleSelectorText(this.brandfilter, "All brands");
        }
        
        if (urlParams.taskExecuterGroup) {
            this.taskExecuterGroupDropdown.setSelectedOption(urlParams.taskExecuterGroup);
            this.syncSingleSelectorText(this.taskExecuterGroupDropdown, "All task executer groups");
        } else {
            this.taskExecuterGroupDropdown.setSelectedOption(null);
            this.syncSingleSelectorText(this.taskExecuterGroupDropdown, "All task executer groups");
        }

        if (urlParams.scheduleType === "time" || urlParams.scheduleType === "every") {
            this.scheduleTypeDropdown.setSelectedOption(urlParams.scheduleType);
            this.refreshExecuteScheduleDropdownOptions();
        }
        
        if (urlParams.executeScheduled) {
            this.executeScheduledDropdown.setSelectedOption(urlParams.executeScheduled);
        }
    }

    public setItems(items): void {
        items = items.map(function (item) {
            return {
                ...item,
                extraInfo: item.extraInfo ? JSON.stringify(item.extraInfo) : ""
            };
        });
    
        this.getTemplateViewModel().items(items);
    }

    public setBrandFilterItems(brands): void {
        let options = brands.map(function (brand) {
            return { id: brand.id, name: brand.name };
        });
    
        this.brandfilter.setOptions([
            { id: null, name: "All brands" },
            ...options
        ]);
    }

    public setTaskExecuterGroupFilterItems(groups): void {
        let options = groups.map(function (group) {
            return { id: group.id, name: group.name };
        });
    
        this.taskExecuterGroupDropdown.setOptions([
            { id: null, name: "All task executer groups" },
            ...options
        ]);
    }

    public setExecuteSchedules(executeSchedules): void {
        this.getTemplateViewModel().executeSchedules(executeSchedules);
        this.refreshExecuteScheduleDropdownOptions();
    }

    public setPagination(totalCount): void {
        this.getTemplateViewModel().pagination.itemCount(totalCount);
    }

    public setPermissions(permissions): void {
        this.getTemplateViewModel().permissions(permissions);
    }

    public setValidationMessages(messages): void {
        this.validationsList.setMessages(messages);
    }

    public setResultInfo(nbResults, nbPages, execTime): void {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public resetPageNumber(): void {

        this.getTemplateViewModel().pagination.pageNumber(1);
    }

    public showAddPopup(): void {

        let vm = this.getTemplateViewModel();
        vm.popupAction("add");
        vm.form.id(null);
        vm.form.idOperation(null);
        vm.form.idTaskExecuter(null);
        vm.form.scheduleMode("every");
        vm.form.scheduleEveryValue("1");
        vm.form.scheduleEveryUnit("h");
        vm.form.scheduleTime("01:00");
        vm.form.executeScheduled("");
        vm.form.extraInfo("");
        this.validationsList.clearMessages();

        this.operationFormAutocomplete.clearInputNoCallback();
        this.taskExecuterFormAutocomplete.clearInputNoCallback();
        vm.isVisible(true);
    }

    public showEditPopup(data): void {

        let vm = this.getTemplateViewModel();
        vm.popupAction("edit");
        vm.form.id(data.id);
        vm.form.idOperation(data.idOperation);
        this.operationFormAutocomplete.clearInputNoCallback();
        this.taskExecuterFormAutocomplete.clearInputNoCallback();
        vm.form.idTaskExecuter(data.idTaskExecuter);
        vm.form.executeScheduled(data.executeScheduled);
        this.setScheduleFieldsFromExecuteScheduled(data.executeScheduled);
        vm.form.extraInfo(data.extraInfo);
        this.validationsList.clearMessages();
        vm.isVisible(true);
    }

    public hidePopup(): void {

        this.validationsList.clearMessages();
        this.getTemplateViewModel().isVisible(false);
    }

    public getFormData() {

        let form = this.getTemplateViewModel().form;

        return {
            id: form.id(),
            idOperation: form.idOperation(),
            idTaskExecuter: form.idTaskExecuter(),
            executeScheduled: this.buildExecuteScheduled(),
            extraInfo: form.extraInfo()
        };
    }

    public refreshExecuteScheduleDropdownOptions(): void {
        let scheduleType = this.getTemplateViewModel().scheduleTypeDropdown.selectedOption();
    
        let executeSchedules = this.getTemplateViewModel().executeSchedules().filter(function (schedule) {
            return !scheduleType || schedule.type === scheduleType;
        });
    
        this.executeScheduledDropdown.setOptions([
            { id: null, name: "All schedules" },
            ...executeSchedules
        ]);
    
        this.executeScheduledDropdown.setSelectedOption(null);
    }

    protected onClickReorder(field): void {

        let vm = this.getTemplateViewModel();
    
        vm.orderBy(field);
    
        if (vm.orderByAndDirection().includes(field)) {
            vm.orderByDirection(vm.orderByDirection() === "DESC" ? "ASC" : "DESC");
        } else {
            vm.orderByDirection("DESC");
        }
    
        vm.orderByAndDirection(field + "_" + vm.orderByDirection());
    
        this.caller.reorderList();
    }

    protected buildExecuteScheduled(): string {
        let form = this.getTemplateViewModel().form;
    
        if (form.scheduleMode() === "time") {
            if (!form.scheduleTime()) {
                return "";
            }
        
            let timeParts = form.scheduleTime().split(":");
            let hour = parseInt(timeParts[0], 10);
            let minutes = timeParts[1];
        
            return "time" + hour + ":" + minutes;
        }
    
        if (form.scheduleMode() === "every") {
            return form.scheduleEveryValue() && form.scheduleEveryUnit()
                ? "every" + form.scheduleEveryValue().toString().trim() + form.scheduleEveryUnit()
                : "";
        }
    
        return "";
    }

    protected isFormValid(): boolean {

        let form = this.getTemplateViewModel().form;
        let messages = [];
        let executeScheduled = this.buildExecuteScheduled();
    
        if (!form.idOperation()) {
            messages.push({
                field: "idOperation",
                label: "Operation",
                messages: ["Please select an operation."]
            });
        }
    
        if (!form.idTaskExecuter()) {
            messages.push({
                field: "idTaskExecuter",
                label: "Task Executer",
                messages: ["Please select a task executer."]
            });
        }

        if (form.scheduleMode() === "every") {
            let everyValueRaw = form.scheduleEveryValue().toString().trim();
        
            if (!/^[1-9][0-9]*$/.test(everyValueRaw)) {
                messages.push({
                    field: "executeScheduled",
                    label: "Execute Scheduled",
                    messages: ["Run every must be a whole number greater than 0."]
                });
            }
        
            if (form.scheduleEveryUnit() !== "m" && form.scheduleEveryUnit() !== "h") {
                messages.push({
                    field: "executeScheduled",
                    label: "Execute Scheduled",
                    messages: ["Please select minutes or hours."]
                });
            }
        }
        
        if (form.scheduleMode() === "time") {
            if (!/^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(form.scheduleTime())) {
                messages.push({
                    field: "executeScheduled",
                    label: "Execute Scheduled",
                    messages: ["Please select a valid time."]
                });
            }
        }

        if (messages.length > 0) {
            this.validationsList.setMessages(messages);
            return false;
        }
    
        this.validationsList.clearMessages();
        return true;
    }

    protected setScheduleFieldsFromExecuteScheduled(executeScheduled: string): void {
        let form = this.getTemplateViewModel().form;
        let everyMatches = executeScheduled.match(/^every([1-9][0-9]*)([mh])$/);
        let timeMatches = executeScheduled.match(/^time([0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/);
    
        if (everyMatches) {
            form.scheduleMode("every");
            form.scheduleEveryValue(everyMatches[1]);
            form.scheduleEveryUnit(everyMatches[2]);
        } else if (timeMatches) {
            form.scheduleMode("time");
            form.scheduleTime(("0" + timeMatches[1]).slice(-2) + ":" + timeMatches[2]);
        }
    }

    protected syncSingleSelectorText(selector: any, allLabel: string): void {
        const vm = selector.getTemplateViewModel();
        const selectedId = vm.selectedOption();
        const options = vm.options() || [];
    
        const match = options.find((o) => String(o.id) === String(selectedId));
        selector.setselectedOptionText(match ? match.name : allLabel);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/task_scheduling_template.ts